import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { isNullOrEmpty } from '@/utils/vuex';
export default {
  name: 'CoreTenantScopeAccessSelector',
  props: {
    subject: {
      type: String,
      required: false,
      default: 'UserManagement'
    },
    action: {
      type: String,
      required: false,
      default: 'manage'
    },
    userId: {
      type: String,
      required: false,
      default: ''
    },
    roles: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    allowEmptyRoleSet: {
      type: Boolean,
      required: false,
      default: function _default() {
        return false;
      }
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      stepperIndex: 1,
      selectedScope: {},
      chosenRoles: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'color'])), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }),
  watch: {
    roles: function roles() {
      this.chosenRoles = this.roles;
    }
  },
  methods: {
    isNullOrEmpty: isNullOrEmpty,
    didSelectScope: function didSelectScope(scope) {
      this.selectedScope = scope;
      this.stepperIndex = 2;
      this.$emit('scopeChosen', this.selectedScope.id);
    },
    rolesChosen: function rolesChosen(roles) {
      this.chosenRoles = roles;
    },
    emitRoles: function emitRoles() {
      // NOTE: the tenantId is delivered from the scope-tree request just as `tenant`!
      this.$emit('scopeRolesChosen', this.chosenRoles, this.selectedScope.id, this.selectedScope.tenant);
      this.resetForm();
    },
    resetForm: function resetForm() {
      this.stepperIndex = 1;
      this.selectedScope = {};
    }
  }
};